<template>
  <v-container class="pa-0"  fluid>
    <component :is="routeItems[activeRoute].component" class=""></component>
  </v-container>
</template>

<script>
import { authRoute } from '@/router/routeRole'
import Institutions from '@/views/classifiers/institutions/Institutions'
import AdminInstitutionForm from '@/views/classifiers/institutions/AdminInstitutionForm'
import RejectReasons from '@/views/classifiers/rejectReasons/RejectReasons'
import AdminRejectReasonForm from '@/views/classifiers/rejectReasons/AdminRejectReasonForm'
import EmailAndSms from '@/views/classifiers/emailAndSms/EmailAndSms'
import AdminEmailAndSmsForm from '@/views/classifiers/emailAndSms/AdminEmailAndSmsForm'
import MandateTermination from '@/views/classifiers/mandateTermination/MandateTermination'
import AdminMandateTerminationForm from '@/views/classifiers/mandateTermination/AdminMandateTerminationForm'
import MandateSuspension from '@/views/classifiers/mandateSuspension/MandateSuspension'
import AdminMandateSuspensionForm from '@/views/classifiers/mandateSuspension/AdminMandateSuspensionForm'
import SecurityNotifications from '@/views/classifiers/securityNotifications/SecurityNotifications'
import AdminSecurityNotificationForm from '@/views/classifiers/securityNotifications/AdminSecurityNotificationForm'
import InstitutionGroups from '@/views/classifiers/institutionGroups/InstitutionGroups'
import AdminInstitutionGroupForm from '@/views/classifiers/institutionGroups/AdminInstitutionGroupForm'
import ErrorNotifications from '@/views/classifiers/errorNotifications/ErrorNotifications'
import AdminErrorNotificationForm from '@/views/classifiers/errorNotifications/AdminErrorNotificationForm'
import Tooltips from '@/views/classifiers/tooltips/Tooltips'
import AdminTooltipForm from '@/views/classifiers/tooltips/AdminTooltipForm'
import MandateTypes from '@/views/classifiers/mandateTypes/MandateTypes'
import AdminMandateTypeForm from '@/views/classifiers/mandateTypes/AdminMandateTypeForm'
import AdminServiceForm from '@/views/classifiers/services/AdminServiceForm'
import AdminServiceImportForm from '@/views/classifiers/services/AdminServiceImportForm'
import AdminParentServiceForm from '@/views/classifiers/services/AdminServiceForm'
import Services from '@/views/classifiers/services/Services'
import CancelReasons from '@/views/classifiers/cancelReasons/CancelReasons'
import AdminCancelReasonForm from '@/views/classifiers/cancelReasons/AdminCancelReasonForm'
import Countries from '@/views/classifiers/countries/Countries'
import AdminCountryForm from '@/views/classifiers/countries/AdminCountryForm'
import AuthorizingPersons from '@/views/classifiers/authorizingPersons/AuthorizingPersons'
import AdminAuthorizingPersonForm from '@/views/classifiers/authorizingPersons/AdminAuthorizingPersonForm'
import IpasasJaPermissions from '@/views/classifiers/ipasasJaPermissions/ipasasJaPermissions'
import ipasasFaPermissions from '@/views/classifiers/ipasasFaPermissions/ipasasFaPermissions'
import ipasasFaPermissionsForm from './ipasasFaPermissions/ipasasFaPermissionsForm'
import ipasasJaPermissionsForm from './ipasasJaPermissions/ipasasJaPermissionsForm'
import CustomCalendar from './customCalendar/CustomCalendar'
import CustomCalendarForm from './customCalendar/CustomCalendarForm'
import NirvarLimit from './nirvarLimits/NirvarLimit'
import NirvarLimitForm from './nirvarLimits/NirvarLimitForm'
import PersonDocumentKind from './personDocumentKinds/PersonDocumentKind'
import PersonDocumentKindForm from './personDocumentKinds/PersonDocumentKindForm'
import ServiceLimitationForm from '@/views/classifiers/rcSesLimitations/serviceLimitations/ServiceLimitationForm'
import ListLimitationForm from '@/views/classifiers/rcSesLimitations/listLimitations/ListLimitationForm'
import RcSesLimitationIndex from '@/views/classifiers/rcSesLimitations/rcSesLimitationsIndex'

export default {
  name: 'ClassifierTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Paslaugos ir veiksmai',
          route: 'classifierServices',
          component: Services,
        },
        {
          title: 'Paslauga / veiksmas',
          route: 'adminServiceForm',
          component: AdminServiceForm,
        },
        {
          title: 'Paslauga / veiksmas',
          route: 'adminParentServiceForm',
          component: AdminParentServiceForm,
        },
        {
          title: 'Paslaugų įkėlimas',
          route: 'adminServiceImportForm',
          component: AdminServiceImportForm,
        },
        {
          title: 'Įgaliojimo tipai',
          route: 'classifierMandateTypes',
          component: MandateTypes,
        },
        {
          title: 'Įgaliojimo tipas',
          route: 'adminMandateTypeForm',
          component: AdminMandateTypeForm,
        },
        {
          title: 'Institucijos',
          route: 'classifierInstitutions',
          component: Institutions,
        },
        {
          title: 'Institucija',
          route: 'adminInstitutionForm',
          component: AdminInstitutionForm,
        },
        {
          title: 'Institucijų grupės',
          route: 'classifierInstitutionsGroups',
          component: InstitutionGroups,
        },
        {
          title: 'Institucijų grupė',
          route: 'adminInstitutionGroupForm',
          component: AdminInstitutionGroupForm,
        },
        {
          title: 'Įgaliojimo pasibaigimo ir pakeitimo pagrindai',
          route: 'classifierMandateTermination',
          component: MandateTermination,
        },
        {
          title: 'Naujas įgaliojimo pasibaigimo pagrindas',
          route: 'adminMandateTerminationForm',
          component: AdminMandateTerminationForm,
        },
        {
          title: 'Įgaliojimo pasibaigimo ir pakeitimo pagrindai',
          route: 'classifierMandateSuspension',
          component: MandateSuspension,
        },
        {
          title: 'Naujas įgaliojimo pasibaigimo pagrindas',
          route: 'adminMandateSuspensionForm',
          component: AdminMandateSuspensionForm,
        },
        {
          title: 'Atsisakymo pagrindai',
          route: 'classifierRejectReasons',
          component: RejectReasons,
        },
        {
          title: 'Nauja atsisakymo išregistruoti įgaliojimą priežastis',
          route: 'adminRejectReasonForm',
          component: AdminRejectReasonForm,
        },
        {
          title: 'El. pašto ir SMS tekstai',
          route: 'classifierEmailAndSMS',
          component: EmailAndSms,
        },
        {
          title: 'Šablonas',
          route: 'adminEmailAndSmsForm',
          component: AdminEmailAndSmsForm,
        },
        {
          title: 'Šalys',
          route: 'classifierCountries',
          component: Countries,
        },
        {
          title: 'Šalis',
          route: 'adminCountryForm',
          component: AdminCountryForm,
        },

        {
          title: 'Panaikinimo / atsisakymo požymiai',
          route: 'classifierCancelReasons',
          component: CancelReasons,
        },
        {
          title: 'Panaikinimo / atsisakymo požymis',
          route: 'adminCancelReasonForm',
          component: AdminCancelReasonForm,
        },
        {
          title: 'Informaciniai ir klaidų pranešimai',
          route: 'classifierErrorNotifications',
          component: ErrorNotifications,
        },
        {
          title: 'Informacinis / klaidos pranešimas',
          route: 'adminErrorNotificationForm',
          component: AdminErrorNotificationForm,
        },
        {
          title: 'Saugos pranešimai',
          route: 'classifierSecurityNotifications',
          component: SecurityNotifications,
        },
        {
          title: 'Saugos pranešimas',
          route: 'adminSecurityNotificationForm',
          component: AdminSecurityNotificationForm,
        },
        {
          title: 'Patartys (angl. tooltips)',
          route: 'classifierTooltips',
          component: Tooltips,
        },
        {
          title: 'Patartis (angl. tooltip)',
          route: 'adminTooltipForm',
          component: AdminTooltipForm,
        },
        {
          title: 'Įgaliojimą tvirtinantys asmenys',
          route: 'classifierAuthorizingPersons',
          component: AuthorizingPersons,
        },
        {
          title: 'Įgaliojimą tvirtinantis asmuo',
          route: 'adminAuthorizingPersonForm',
          component: AdminAuthorizingPersonForm,
        },
        {
          title: 'iPasas teisės (JA)',
          route: 'ipasasJaPermissions',
          component: IpasasJaPermissions,
        },
        {
          title: 'iPasas teisė (JA)',
          route: 'ipasasJaPermissionForm',
          component: ipasasJaPermissionsForm,
        },
        {
          title: 'iPasas teisės (FA)',
          route: 'ipasasFaPermissions',
          component: ipasasFaPermissions,
        },
        {
          title: 'iPasas teisė (FA)',
          route: 'ipasasFaPermissionForm',
          component: ipasasFaPermissionsForm,
        },
        {
          title: 'NIRVAR sritys',
          route: 'nirvarLimit',
          component: NirvarLimit,
        },
        {
          title: 'NIRVAR sritis',
          route: 'nirvarLimitForm',
          component: NirvarLimitForm,
        },
        {
          title: 'Asmens dokumento rūšys',
          route: 'personDocumentKind',
          component: PersonDocumentKind,
        },
        {
          title: 'Asmens dokumento rūšis',
          route: 'personDocumentKindForm',
          component: PersonDocumentKindForm,
        },
        {
          title: 'Šventinių dienų sąrašas',
          route: 'customCalendar',
          component: CustomCalendar,
        },
        {
          title: 'Šventinė diena',
          route: 'customCalendarForm',
          component: CustomCalendarForm,
        },
        {
          title: 'RC SES apribojimai',
          route: 'serviceLimitation',
          component: RcSesLimitationIndex,
        },
        {
          title: 'Paslaugos apribojimai',
          route: 'serviceLimitationForm',
          component: ServiceLimitationForm,
        },
        {
          title: 'Sąrašo apribojimai',
          route: 'listLimitationForm',
          component: ListLimitationForm,
        },
        {
          route: 'serviceLimitation',
          component: RcSesLimitationIndex,
        },
        {
          route: 'listLimitation',
          component: RcSesLimitationIndex,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter((item) => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function (item, index) {
          return this.$route.matched.find((element) => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function (item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
